import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UserService} from "./services/user.service";
import {XsrfInterceptor} from "./interceptors/xsrf.interceptor";
import {XsrfTokenReader} from "./services/xsrf-token-reader.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [UserService, XsrfInterceptor, XsrfTokenReader]
})
export class PmLibraryModule { }
